import { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import InCountry from "../../Components/InCountry/InCountry";
import s from "./InKazakhstan.module.scss";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import CountriesButtons from "../../Components/CountriesButtons/CountriesButtons";
import DiseaseButtons, {
  IDisease,
} from "../../Components/DiseaseButtons/DiseaseButtons";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getIamInKazahkstan,
  getKazakhstanDiseaseList,
} from "../../redux/InformationSlice";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

const InKazakhstan = () => {
  const dispatch: AppDispatch = useDispatch();

  const inKazahkstanInfo = useSelector(
    (state: RootState) => state.info.inKazahkstanInfo,
  );
  const { t } = useTranslation();
  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const { width } = useWindowDimensions();

  const diseaseList = useSelector(
    (state: RootState) => state.info.kazakhstanDiseaseList,
  );

  useEffect(() => {
    dispatch(getIamInKazahkstan());
    dispatch(getKazakhstanDiseaseList());
  }, []);

  return (
    <div>
      <Seo
        title="Медосмотр для мигрантов перед выездом в Казахстан"
        description="Список заболеваний, при которых нельзя получить вид на жительство (ВНЖ) в Казахстане"
        url="https://www.vputi.org/kazakhstan"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <div className={s.inner}>
          <InCountry />
          <Navigation
            navigation={{
              name: "Главная / Законодательство Казахстана",
              path: "/",
            }}
          />
          <ContactButtons />
          <CountriesButtons />
          <div className={s.text_1}>
            <div className={s.image}>
              <img className={s.img} src={inKazahkstanInfo?.image} />
            </div>
            <div className={s.text_1_wrapper}>
              <div className={s.text_title}>{inKazahkstanInfo?.title_1}</div>
              <div
                dangerouslySetInnerHTML={{
                  __html: inKazahkstanInfo?.body_1 ?? "",
                }}
                className={s.decription}
              />
            </div>
          </div>
          <div className={s.text_2}>
            <div className={s.title_2}>{inKazahkstanInfo?.title_2}</div>
            <div
              className={s.description_2}
              dangerouslySetInnerHTML={{
                __html: inKazahkstanInfo?.body_2 ?? "",
              }}
            ></div>
          </div>
          <div className={s.text_3}>
            <div className={s.title_3}>{inKazahkstanInfo?.title_3}</div>
            <div
              className={s.description_3}
              dangerouslySetInnerHTML={{
                __html: inKazahkstanInfo?.body_3 ?? "",
              }}
            ></div>
          </div>

          <DiseaseButtons
            diseases={[...(diseaseList || [])].reverse()?.map((it) => ({
              id: it.id,
              button: it.button,
              button_ru: it.button,
              button_kg: it.button_ky,
              button_uz: it.button_uz,
              button_tj: it.button_tg,
            }))}
            country="kazakhstan"
          />

          <div className={s.title}>
            {t("Где я могу пройти обследования на родине?")}
          </div>
          <CountriesBlueButtons />
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default InKazakhstan;
